module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        // showColorBar: true,
        tabConfigNavKey: 'dashboard',
        // showEditByMySelf: true,
    },
}